import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

import Select from "react-select"
import {
  createBranch,
  getDistricts,
  getStates,
  updateBranch,
} from "store/actions"
import UseImageUploader from "components/imageUploader/useImageUploader"

const BranchModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()

  const { allDistricts, allState, loading } = useSelector(state => ({
    allState: state?.Client?.states?.States,
    allDistricts: state?.Client?.districts?.districts,
    loading: state?.Branches.loading,
  }))

  const [imagePreview, setImagePreview] = useState([])

  const [state, setState] = useState("")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("")
  const [districtId, setDistrictId] = useState("")
  const [districtSearch, setDistrictSearch] = useState("")

  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch])

  useEffect(() => {
    setDistrictId(updateData?.district?._id)
    setDistrict(updateData?.district?.name)

    setState(updateData?.state?.name)
    setStateId(updateData?.state?._id)
  }, [updateData])

  const stateOptions = [
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
  }

  useEffect(() => {
    dispatch(getDistricts(stateId, districtSearch))
  }, [dispatch, stateId, districtSearch])

  useEffect(() => {
    setImagePreview(updateData?.image ? updateData?.image : [])
  }, [dispatch, updateData])

  const districtOptions = [
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
  }

  const handleValidSubmit = (e, v) => {
    const branchUpdate = {
      branch_name: v.branch_name,
      personal_number: v.personal_number,
      description: v.description,
      location: v.location,
      image: imagePreview,
      state: stateId,
      district: districtId,
      branch_admin: v.branch_admin,
    }

    if (updateData?._id) {
      dispatch(updateBranch(branchUpdate, updateData?._id, onCloseClick))
    } else {
      dispatch(createBranch(branchUpdate, onCloseClick))
    }
  }

  console.log(updateData)

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Branch Details" : "Add New Branch"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <Col className="col-6 mb-2">
              <label>
                Branch Name <span className="text-danger"> *</span>
              </label>
              <AvField
                name="branch_name"
                type="text"
                placeholder="Enter Branch Name"
                value={updateData?.branch_name}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Branch name is required",
                  },
                }}
              />
            </Col>
            <Col className="col-6">
              <label>Phone</label>
              <AvField
                name="personal_number"
                type="number"
                placeholder="Enter Number"
                value={updateData?.personal_number}
              />
            </Col>
            <Col className="col-6 mt-2">
              <label>Description</label>
              <AvField
                name="description"
                type="textarea"
                placeholder="Enter description"
                value={updateData?.description}
                multiline
                rows="5"
              />

              <div className="mt-2">
                <label>Location</label>
                <AvField
                  name="location"
                  type="text"
                  placeholder="Enter location"
                  value={updateData?.location}
                />
              </div>
            </Col>
            <Col className="col-6 mt-2">
              <UseImageUploader
                imageSize={4}
                setImagesPreview={setImagePreview}
                imagesPreview={imagePreview}
                uploadUrl={"/focusmotors"}
                // isMultiple
              />
            </Col>

            <Col className="col-6 mt-2 mb-4">
              <label>State</label>
              <Select
                onInputChange={handleEnteredStates}
                value={state}
                placeholder={state}
                onChange={handleFinalValuesStates}
                options={stateOptions}
                classNamePrefix="select2-selection"
                isLoading={""}
              />
            </Col>
            <Col className="col-6 mt-2 mb-4">
              <label>District</label>
              <Select
                onInputChange={handleEnteredDistrict}
                value={district}
                placeholder={district}
                onChange={handleFinalValuesDistrict}
                options={districtOptions}
                classNamePrefix="select2-selection"
                isLoading={""}
              />
            </Col>

            <hr />
            <p style={{ fontWeight: "bolder" }}>Admin Details</p>

            <Col className="col-4">
              <label>
                Name <span className="text-danger"> *</span>
              </label>
              <AvField
                name="branch_admin.name"
                type="text"
                placeholder="Enter admin name"
                value={updateData?.branch_admin?.name}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Admin name is required",
                  },
                }}
              />
            </Col>
            <Col className="col-4">
              <label>
                Phone <span className="text-danger"> *</span>
              </label>
              <AvField
                name="branch_admin.phone"
                type="text"
                placeholder="Enter admin phone"
                value={updateData?.branch_admin?.phone}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Phone number is required",
                  },
                }}
              />
            </Col>

            <Col className="col-4 ">
              <label>
                Email <span className="text-danger"> *</span>
              </label>
              <AvField
                name="branch_admin.email"
                type="mail"
                placeholder="Enter admin email"
                value={updateData?.branch_admin?.email ?? ""}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Admin email is required",
                  },
                }}
              />
            </Col>
            <Col className="col-12 mt-2">
              <AvField
                name="branch_admin.address"
                label="Address"
                type="textarea"
                placeholder="Enter admin address"
                value={updateData?.branch_admin?.address}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
                {loading ? <i className="fas fa-spinner fa-spin ms-2"></i> : ""}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

BranchModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default BranchModal
